import React from "react"
import type { StyleProps } from "@mallardbay/lib-react-components"
import { Button, useColors } from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"
import type { QuoteFieldsFragment } from "~graphql/generated/graphql"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import { CHECKOUT_STEPS } from "~config/constants"

interface Props {
    readonly quote?: QuoteFieldsFragment | null
}

export default function AddAnotherPackageButton({ quote }: Props) {
    const styles = useStyles()
    const { updatePackageState, goToStep } = useCheckoutFlow()

    // This is used in components shared by checkout flow and summary pages.
    // In the checkout flow, there is no quote passed and this button should be hidden.
    // Should also be hidden if the quote was created from a booking invite.
    if (!quote || quote.booking_invite) return null

    return (
        <Button
            style={styles.root}
            // Goes to checkout flow with the quote id in the search params. Checkout flow is
            // used for initial package, editing, and adding additional depending on params.
            onClick={() => {
                updatePackageState({
                    pricing_package_id: null,
                    number_of_guests: undefined,
                    add_ons: null,
                })
                goToStep({
                    quote_id: quote.id,
                    step: CHECKOUT_STEPS.PACKAGE,
                    checkout_state: null,
                })
            }}
        >
            {COPY.ADD_ANOTHER_PACKAGE}
        </Button>
    )
}

function useStyles() {
    const colors = useColors()
    const root: StyleProps = {
        marginBottom: "16px",
        backgroundColor: colors.buttonBackgroundSecondary,
        color: colors.inverseText,
        height: "48px",
    }

    return {
        root,
    }
}
